export default __webpack_public_path__ + "static/media/ECW-Desktop.67b76364.png";